import DatabaseModel from './DatabaseModel.js';

var TarifaHerramienta = Object.create(DatabaseModel);
TarifaHerramienta.model = 'tarifa-herramientas';
TarifaHerramienta.modelFront = 'tarifa-herramientas';

TarifaHerramienta.getList = function() {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/',
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false).then(function(res) {
        // ResponseDto unwrapped by sendRequest → res is either the array directly,
        // or {list:[...]} if wrapped, or the raw dto
        if (Array.isArray(res)) return res;
        if (res && res.list) return res.list;
        if (res && Array.isArray(res.dto)) return res.dto;
        return [];
    });
};

/**
 * Todas las versiones de una herramienta, vigente o no, de la mas nueva a la mas vieja. La calculadora
 * la usa para reabrir una linea de oferta con la version con la que se guardo (#467).
 */
TarifaHerramienta.getHistorial = function(codigo) {
    const self = this;
    const request = {
        url: self.server_movilidad + self.prefix + self.model + '/historial/' + encodeURIComponent(codigo),
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false).then(function(res) {
        if (Array.isArray(res)) return res;
        if (res && res.list) return res.list;
        if (res && Array.isArray(res.dto)) return res.dto;
        return [];
    });
};

TarifaHerramienta.getByCodigo = function(codigo) {
    var self = this;
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/codigo/' + codigo,
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false);
};

/**
 * Las claves que son de la Configuracion global de tarifas y NO de la herramienta (#387).
 *
 * Es la misma lista cerrada que la API: `ConfigHerramientaClavesGlobales` en movilidad. Esta
 * duplicada porque entre los dos repos no hay contrato publicado -el contrato es el codigo-, asi
 * que si se toca una hay que tocar la otra; el motivo de que exista aqui esta en `sinClavesGlobales`.
 *
 * `kmmin` en minusculas NO esta: es el unico valor de la copia que el calculador lee de verdad de la
 * herramienta (`kmminEfectivo`), o sea un override legitimo, y Ascensores mantiene el suyo a 0,1 por
 * decision de direccion del 07/10/2026.
 */
TarifaHerramienta.CLAVES_GLOBALES = [
    'ph', 'phRite', 'kmcost', 'tdf', 'com', 'cen', 'hot', 'des', 'hcom', 'hhot', 'pctFS', 'pctNocturno',
    'id', 'version', 'creadoPor', 'usuarioModificacion', 'fechaModificacion', 'fechaDesde', 'fechaHasta',
    'motivo',
    'PH', 'PHRITE', 'KMCOST', 'KMMIN', 'TDF', 'COM', 'CEN', 'HOT', 'DES', 'HCOM', 'HHOT', 'PCTFS',
    'PCTNOCTURNO'
];

/**
 * Los nombres de campo que se EVALUAN como JavaScript, alla donde esten dentro de `secciones` o de
 * `alertas`.
 *
 * `condicion` es la de cada alerta y la de la visibilidad de una seccion o un widget
 * (`TarifaRenderer.evaluarCondicion`), `visible` es la misma cosa escrita en el widget
 * (`isWidgetVisible`, y `tarifa-calculador-v3.isVisible`), y `value` es cada linea de un widget de
 * formula (`TarifaRenderer.getFormulaLines` -> `evaluarExpresion`).
 *
 * Por nombre y no por posicion: `secciones` no tiene forma declarada en ningun sitio, asi que
 * enumerar «seccion -> widgets -> lineas» se rompe en cuanto el editor anida un nivel mas.
 *
 * POR QUE `value` SE QUEDA, AUNQUE HOY NO LO EVALUE NINGUNA PANTALLA
 *
 * Una ronda de revision del PR #1793 pidio quitarlo, y la mitad de su razon es cierta y esta
 * comprobada: la pantalla que calcula, `tarifa-calculador-v3.vue`, solo evalua `formula.tpc`,
 * `formula.tpi`, `alertas[].condicion` y `visible`; y el editor de herramientas no ofrece ningun
 * widget de tipo formula, asi que hoy nadie escribe un `lines[].value`. Lo que no es cierto es que
 * en este repositorio nadie evalue un `value`: lo hace `TarifaRenderer.vue` (el `new Function('form',
 * 'params', ...)` de `evaluarExpresion`, que recibe cada `l.value` de `getFormulaLines`). Ese
 * componente esta hoy HUERFANO -ninguna pantalla lo importa ni lo registra-, y eso es exactamente lo
 * que hace que el coste de dejar `value` aqui sea cero hoy y el de quitarlo no lo sea manana.
 *
 * La API dice lo mismo en `ConfigHerramientaClavesGlobales.CAMPOS_DE_EXPRESION`, y las dos tienen
 * que seguir diciendolo: aflojar solo un lado es peor que dejarlo, porque entonces el editor guarda
 * lo que la limpieza ha decidido no tocar.
 */
const CAMPOS_DE_EXPRESION = ['condicion', 'visible', 'value'];

/**
 * Lo que se ha encontrado en los campos de expresion. El orden es el de prudencia: `peor` se queda
 * con el valor mas alto, asi que un solo campo con expresion -o uno con forma desconocida- decide
 * por toda la herramienta.
 */
const SIN_EXPRESION = 0;
const CON_EXPRESION = 1;
const DESCONOCIDA = 2;

function peor(una, otra) {
    return una >= otra ? una : otra;
}

function esContenedor(valor) {
    return valor !== null && typeof valor === 'object';
}

/**
 * Lo que cuelga de un campo de expresion.
 *
 * Un texto no vacio es una expresion y ya esta: no se lee. Un numero o un booleano tambien cuentan,
 * porque el calculador los pega al cuerpo de la funcion igual que un texto (`'return ' + w.visible`),
 * asi que son una expresion constante. Un contenedor se recorre -una `condicion` o un `value`
 * anidados siguen siendo expresiones- y lo que no es ninguna de esas cosas no se reconoce.
 *
 * Vacio o ausente no es expresion: un `condicion: ''` no lo evalua nadie -el calculador y el
 * renderer salen por el `if (!cond) return true`- y tratarlo como expresion retendria herramientas
 * por un campo que el editor deja puesto y en blanco.
 */
function valorDeExpresion(valor) {
    if (valor === null || valor === undefined) return SIN_EXPRESION;
    if (typeof valor === 'string') return valor.trim() === '' ? SIN_EXPRESION : CON_EXPRESION;
    if (esContenedor(valor)) return dentroDelContenedor(valor, true);
    if (typeof valor === 'number' || typeof valor === 'boolean') return CON_EXPRESION;
    return DESCONOCIDA;
}

/**
 * Lo que cuelga de un campo que nadie evalua: un titulo, un mensaje, una etiqueta, un orden.
 *
 * No retiene nada por si mismo -si lo hiciera, un mensaje de alerta que diga «revisa params»
 * dejaria la herramienta sin limpiar para siempre-, pero se sigue bajando por dentro: los `widgets`
 * de una seccion cuelgan de una clave que no es de expresion y llevan dentro los `visible` y los
 * `value` que si lo son.
 */
function dentroDeLoQueNadieEvalua(valor) {
    return esContenedor(valor) ? dentroDelContenedor(valor, false) : SIN_EXPRESION;
}

function dentroDelContenedor(valor, todoEsExpresion) {
    let forma = SIN_EXPRESION;
    if (Array.isArray(valor)) {
        valor.forEach(function(anidado) {
            forma = peor(forma, todoEsExpresion
                ? valorDeExpresion(anidado)
                : dentroDeLoQueNadieEvalua(anidado));
        });
        return forma;
    }
    Object.keys(valor).forEach(function(clave) {
        const esCampoDeExpresion = todoEsExpresion || CAMPOS_DE_EXPRESION.indexOf(clave) >= 0;
        forma = peor(forma, esCampoDeExpresion
            ? valorDeExpresion(valor[clave])
            : dentroDeLoQueNadieEvalua(valor[clave]));
    });
    return forma;
}

/**
 * Las tres raices donde pueden vivir expresiones: si TODO lo que cuelga de ellas se evalua, y de
 * que forma tiene que venir el contenedor.
 *
 * `todoEsExpresion` en `formula` si: sus dos campos son las expresiones del TPC y del TPI. En
 * `alertas` y en `secciones` no: ahi solo se evaluan los `CAMPOS_DE_EXPRESION`, y el resto son
 * titulos y mensajes.
 *
 * `lista` dice cual de los dos contenedores es el bueno, y no es un detalle: no son
 * intercambiables. `formula` es un mapa de dos claves y `alertas` y `secciones` son listas, y un
 * contenedor del otro tipo ni se recorre igual ni se puede editar ni sobrevive al guardado.
 */
const RAICES_DE_EXPRESIONES = [
    { clave: 'formula', todoEsExpresion: true, lista: false },
    { clave: 'alertas', todoEsExpresion: false, lista: true },
    { clave: 'secciones', todoEsExpresion: false, lista: true }
];

function laRaiz(clave) {
    const raiz = RAICES_DE_EXPRESIONES.filter(function(r) { return r.clave === clave; })[0];
    // Preguntar por una raiz que no es de expresiones no tiene respuesta buena: contestar
    // `EDITABLE` dejaria escribir donde la retencion no mira, y contestar `INTOCABLE` apartaria un
    // campo que nadie tenia que apartar. Las dos salidas son silenciosas, asi que se rompe.
    if (!raiz) throw new Error('TarifaHerramienta: `' + clave + '` no es una raiz de expresiones');
    return raiz;
}

/**
 * Si el valor es el contenedor que ESA raiz tiene que traer, y no otro.
 *
 * Un `secciones: {}` o un `formula: []` son contenedores, pero no los suyos, y aceptarlos por ser
 * «un objeto» es lo que encontro la ronda 1 de la revision del PR #1793: `allCampos` hace
 * `secciones.forEach` y revienta la ficha, y en `formula: []` las asignaciones a `tpc` y `tpi`
 * entran -un array es un objeto- pero desaparecen al serializarlo, asi que lo que la persona
 * escribio se pierde sin un solo error. De las dos cosas, la segunda es la grave: el guardado
 * contesta OK y la formula no esta.
 */
function esElContenedorEsperado(valor, lista) {
    if (!esContenedor(valor)) return false;
    return lista ? Array.isArray(valor) : !Array.isArray(valor);
}

/**
 * Una de las tres estructuras donde pueden vivir expresiones, mirada desde su raiz.
 *
 * Ausente es ausente: la version 1 de casi todas las herramientas no tiene ni `formula` ni
 * `secciones`. Pero una raiz que DEBERIA ser un contenedor y no lo es -un `alertas` que es un
 * numero-, o que es un contenedor del otro tipo -un `secciones` que es un mapa-, no se puede
 * recorrer como lo que es, y entonces no se sabe si dentro habia expresiones: se retiene.
 */
function raizDeExpresiones(valor, raiz) {
    if (valor === null || valor === undefined) return SIN_EXPRESION;
    if (esElContenedorEsperado(valor, raiz.lista)) {
        return dentroDelContenedor(valor, raiz.todoEsExpresion);
    }
    return DESCONOCIDA;
}

function formaDeLasExpresiones(herramienta) {
    let forma = SIN_EXPRESION;
    RAICES_DE_EXPRESIONES.forEach(function(raiz) {
        forma = peor(forma, raizDeExpresiones(herramienta[raiz.clave], raiz));
    });
    return forma;
}

/** Las claves de esas raices, para quien las tiene que tratar una por una: el editor. */
TarifaHerramienta.RAICES_DE_EXPRESIONES = RAICES_DE_EXPRESIONES.map(function(raiz) {
    return raiz.clave;
});

/**
 * La forma de una raiz de expresiones vista por quien la va a EDITAR, no por quien la clasifica.
 *
 * - `AUSENTE`: no viene nada, y el editor puede ponerle el contenedor vacio del que parte;
 * - `EDITABLE`: viene EL contenedor de esa raiz, y el editor lo rellena como siempre;
 * - `INTOCABLE`: viene algo que no es ese contenedor -ni un contenedor, o el del otro tipo-, asi que
 *   el editor no sabe representarlo: no lo sustituye por uno vacio, no lo borra y no escribe dentro.
 *   Lo devuelve tal cual al guardar, que es lo que deja a `retencion` verlo como `DESCONOCIDA` y
 *   frenar el guardado diciendolo.
 *
 * Por eso hace falta la CLAVE y no basta el valor (#387, ronda 1 de la revision del PR #1793): el
 * contenedor bueno no es el mismo en las tres raices, y `secciones: {}` o `formula: []` pasaban por
 * editables. Ver `esElContenedorEsperado`, que es el mismo criterio que usa `raizDeExpresiones`.
 *
 * POR QUE ESTO VIVE AQUI Y NO EN EL EDITOR (#387, rondas 2 y 3 de la revision del PR #1793)
 *
 * Porque el editor tenia su propio criterio -«si no tiene claves, aqui no hay nada»- y decidir lo
 * mismo dos veces y de dos maneras distintas le cambiaba el veredicto a `retencion` sin querer, en
 * los dos sentidos: un `formula: {tpc: '', tpi: ''}` lo tomaba por presente y le escribia '0' encima,
 * y entonces se retenia una herramienta que SI se puede limpiar; y un `formula: 7` lo tomaba por
 * ausente -un numero no tiene claves- y lo borraba, con lo que la forma desconocida que habia que
 * RETENER se convertia en «sin expresiones» y se limpiaba. Los dos fallos son el mismo fallo: dos
 * criterios. Ahora hay uno, y el editor pregunta.
 */
TarifaHerramienta.AUSENTE = 'AUSENTE';
TarifaHerramienta.EDITABLE = 'EDITABLE';
TarifaHerramienta.INTOCABLE = 'INTOCABLE';
TarifaHerramienta.formaDeLaRaiz = function(valor, clave) {
    const raiz = laRaiz(clave);
    if (valor === null || valor === undefined) return TarifaHerramienta.AUSENTE;
    return esElContenedorEsperado(valor, raiz.lista)
        ? TarifaHerramienta.EDITABLE : TarifaHerramienta.INTOCABLE;
};

/**
 * Si a esa herramienta NO se le pueden retirar las claves globales que arrastra, y por que.
 *
 * EL CRITERIO, QUE ES UNA DECISION TECNICA Y NO UNA HEURISTICA (11/10/2026, tarde)
 *
 * La regla es de una linea: **si la herramienta arrastra claves globales copiadas y tiene alguna
 * expresion evaluable no vacia, no se retira ninguna de esas claves**. No se mira que dice la
 * expresion, no se busca ningun nombre dentro de ella y no se interpreta JavaScript.
 *
 * Antes si se miraba, y por eso esto se ha reescrito. La version anterior buscaba PALABRAS en el
 * texto de las expresiones -`params`, `config`, `arguments`, `eval`- y de ahi deducia que claves
 * podia retirar. Cuatro rondas de revision de los PR #1793 y #2064 demostraron, una por ronda, otra
 * forma de leer la misma propiedad que ninguna expresion regular veia: `params["ph"]`,
 * `params[clave]`, `arguments[1].ph`, `params./* c *\/ph`, `par\u0061ms.ph` y -la que cerro la
 * discusion- `(function f(){ return f.caller['argu' + 'ments'][1].ph })()`, que obtiene el mismo
 * `params` SIN escribir ninguno de los nombres porque los construye al evaluar. Con el nombre
 * construido en tiempo de ejecucion NINGUNA lista de nombres ni de sintaxis se puede cerrar leyendo
 * el texto, asi que decidir por ausencia de nombres era decidir por una prueba que no demuestra
 * nada: la clave se retiraba de una formula que la lee, el calculo daba `NaN`, el `(tpc || 0)` del
 * calculador lo convertia en CERO y el precio cambiaba EN SILENCIO. Eso es lo que la comprobacion 4
 * de la #387 existe para impedir, asi que no se acepta como deuda: se cierra cambiando la pregunta.
 *
 * Lo que esta pregunta SI puede contestar sin interpretar nada es «¿hay aqui algo que se evalue?».
 * Si lo hay, se retiene; si no lo hay, no hay nada que pueda leer la clave y se retira como siempre.
 * Formulas inocuas y constantes retienen igual: `'35'` o `'form.base * 2'` no leen la configuracion
 * HOY, pero afirmarlo exige leer la expresion, que es justo lo que no se hace.
 *
 * LO QUE ESTO CUESTA, DICHO ENTERO
 *
 * Retiene MAS herramientas que el freno anterior: cualquiera que tenga una formula y arrastre la
 * copia queda retenida, y las 19 vigentes medidas en produccion tienen formula. O sea: la limpieza
 * automatica de esta tanda puede no limpiar ninguna, y lanzar la pasada tampoco las desbloquea,
 * porque aplica este mismo criterio. Es entrega parcial registrada en la #387 y la retirada de esas
 * copias queda pendiente de una solucion revisada posterior. Lo que no se hace, a proposito: no se
 * introduce un analizador de JavaScript, no se evaluan formulas, no se certifica seguridad por
 * ausencia de `params`/`config` ni por comparar unos pocos resultados numericos, y NO hay excepcion
 * manual para retirarlas.
 *
 * RETENER NO ES IMPEDIR GUARDAR (14/10/2026)
 *
 * Esto decide si la aplicacion puede RETIRAR esas claves, y nada mas. Una herramienta retenida se
 * abre, se edita y se guarda como siempre, con su residuo intacto: ver `save`. Mezclar las dos
 * preguntas -«¿se puede retirar?» y «¿se puede guardar?»- dejo la pantalla de Tarifas sin poder
 * guardar nada, que es lo que rechazo ABM en la maquina de pruebas.
 *
 * Sin claves copiadas dentro, una herramienta no queda retenida por este control: tenga las
 * formulas que tenga, no hay nada que retirarle. La API dice exactamente lo mismo en
 * `ConfigHerramientaClavesGlobales.retencion`.
 */
TarifaHerramienta.retencion = function(herramienta, presentes) {
    if (!herramienta || !presentes || !presentes.length) {
        return { retenida: false, claves: [], motivo: null };
    }
    const forma = formaDeLasExpresiones(herramienta);
    if (forma === DESCONOCIDA) {
        return { retenida: true, claves: presentes.slice(), motivo: 'forma' };
    }
    if (forma === CON_EXPRESION) {
        return { retenida: true, claves: presentes.slice(), motivo: 'expresiones' };
    }
    return { retenida: false, claves: [], motivo: null };
};

/**
 * Si ese guardado CREA una herramienta en vez de sustituir una revision que ya existe.
 *
 * Es la misma pregunta que decide el metodo en `save` -`id` puesto es PUT, sin `id` es POST-, y esta
 * aqui una sola vez a proposito: contestarla dos veces y de dos maneras es lo que hacia que el
 * editor le cambiara el veredicto a `retencion` sin querer, y esa forma del fallo ya costo dos
 * rondas en este mismo fichero.
 *
 * Mira el `id` y solo el `id`, que es el que decide el metodo y la URL. Un documento que llegara con
 * `_id` y sin `id` ya iba por POST antes de esto, asi que para la API es un alta igual: tratarlo
 * aqui como actualizacion seria conservarle un residuo que el alta rechaza.
 */
TarifaHerramienta.esAlta = function(herramienta) {
    return !herramienta || !herramienta.id;
};

/**
 * La herramienta con su `config` sin los valores del global, las claves que se han quitado y, si se
 * ha retenido, por que no se ha quitado ninguna.
 *
 * Por que hace falta antes de guardar: el editor abre una herramienta con
 * `JSON.parse(JSON.stringify(h))` y la devuelve tal cual, asi que si la que vino de la API arrastra
 * la copia muerta del 29/03/2026 -174 documentos la arrastran, medido el 08/10/2026- el front se la
 * reenvia al guardar. Para las herramientas SIN expresiones aqui se deja de reenviar lo que no es
 * suyo, y asi guardar desde la ficha limpia lo que la limpieza habria limpiado igual. Los valores no
 * se pierden, estan en Configuracion global de tarifas, que es de donde los lee el calculo.
 *
 * Y para las que SI tienen expresiones no se retira nada y se devuelve `retenida`: retirar un valor
 * que una expresion pudiera usar cambiaria el precio sin avisar. Eso NO impide guardar -se reenvia
 * el `config` tal como vino y la API lo conserva, ver `save`-: lo unico que impide es retirarlo.
 * Ver `TarifaHerramienta.retencion`.
 *
 * LA RETENCION ES DE UN PUT, NO DE UN ALTA (#387, ronda de revision del PR #1793)
 *
 * Conservar el residuo solo se puede en un guardado que sustituye al documento que YA lo tenia: ahi
 * la API lo reescribe con el valor de la predecesora y nada se mueve. En un ALTA no hay predecesora
 * de la que heredarlo, asi que esas claves son NUEVAS en el documento que se crea -que es justo el
 * camino por el que entro el volcado del 29/03/2026- y el guardian de la API las rechaza
 * nombrandolas (`residuoDelGuardado` con predecesora nula, y el alta de `TarifaHerramientaService`).
 * O sea que retener en un alta no conserva nada: deja la herramienta sin crear.
 *
 * Y ocurre: «Duplicar» copia el `config` entero y borra el `id`, asi que duplicar cualquiera de las
 * 19 vigentes -todas arrastran la copia y todas tienen formula- era un guardado rechazado con las 20
 * claves enumeradas. Por eso en un alta se retiran siempre: es lo unico que la API admite.
 *
 * LO QUE ESO NO DECIDE (ronda 2 de la revision del PR #1793)
 *
 * Retirarlas en un alta no es decir que ese alta sea una buena idea. Si la original tenia una formula
 * que leyera una de esas claves -`params` ES el `config` de la herramienta en el calculador, ver
 * `currentParams`-, la copia limpia calcula con `undefined` y el precio sale cero. Eso NO se arregla
 * aqui, porque aqui ya no hay predecesora y no se puede hacer otra cosa: se decide ANTES, al pulsar
 * «Duplicar», y lo decide `motivoNoDuplicar` de `tarifa-editor-herramientas.vue`, que no deja
 * duplicar una herramienta que arrastre el residuo y tenga expresiones. Un alta con esas claves solo
 * podia salir de ahi: una herramienta nueva empieza con el `config` vacio.
 *
 * No toca el objeto que recibe: devuelve una copia. El de la lista lo sigue usando la pantalla.
 */
TarifaHerramienta.sinClavesGlobales = function(herramienta) {
    const nada = { herramienta: herramienta, quitadas: [], retenida: false, motivo: null, claves: [] };
    if (!herramienta?.config) return nada;
    const presentes = [];
    const config = {};
    Object.keys(herramienta.config).forEach(function(clave) {
        if (TarifaHerramienta.CLAVES_GLOBALES.indexOf(clave) >= 0) presentes.push(clave);
        else config[clave] = herramienta.config[clave];
    });
    if (!presentes.length) return nada;

    const retencion = TarifaHerramienta.esAlta(herramienta)
        ? { retenida: false, claves: [], motivo: null }
        : TarifaHerramienta.retencion(herramienta, presentes);
    if (retencion.retenida) {
        return { herramienta: herramienta, quitadas: [], retenida: true,
            motivo: retencion.motivo, claves: retencion.claves };
    }

    const limpia = Object.assign({}, herramienta);
    limpia.config = config;
    return { herramienta: limpia, quitadas: presentes, retenida: false, motivo: null, claves: [] };
};

TarifaHerramienta.save = function(data) {
    const self = this;
    const limpio = TarifaHerramienta.sinClavesGlobales(data);
    if (limpio.retenida) {
        // SE GUARDA IGUAL, con el residuo dentro (#387, 14/10/2026).
        //
        // Aqui se frenaba el guardado con un aviso, y eso dejo la pantalla de Tarifas sin poder
        // guardar NINGUNA herramienta: las 19 vigentes arrastran la copia del global y todas tienen
        // formula, asi que todas quedaban retenidas. Lo probo ABM en la maquina de pruebas con REBT —
        // Baja Tension y dos mas, y el aviso encima mandaba a lanzar la limpieza, que aplica el mismo
        // criterio y tampoco desbloquea: la unica salida que ofrecia era una revision manual de
        // Direccion herramienta por herramienta.
        //
        // Lo que la #387 pide cerrar es que la copia VUELVA A ENTRAR, no que no se pueda guardar lo
        // que ya la tiene: se reenvia el `config` tal como vino -residuo incluido- y la API escribe
        // esas claves con el valor que ya tenian (`residuoDelGuardado`), asi que el guardado pasa, no
        // se introduce ninguna clave nueva y lo que calcula la herramienta no se mueve. Retener sigue
        // significando lo que significaba: que la aplicacion no RETIRA esas claves por su cuenta.
        console.info('[TARIFAS #387] La herramienta ' + (data.codigo || '') + ' se guarda con los'
            + ' valores de la config global que arrastra en su config (' + limpio.claves.join(', ')
            + '): tiene expresiones propias, asi que no se retiran. Los retira la limpieza revisada.');
    } else if (limpio.quitadas.length) {
        // No es un aviso para la persona: es el servidor el que le mando esos valores dentro y no
        // hay nada que decidir. Queda en la consola para que, si alguien mira por que el documento
        // guardado tiene menos claves que el que abrio, lo encuentre.
        //
        // En un alta -duplicar- si se le dice, pero al duplicar y no aqui: ver `duplicarHerramienta`.
        console.info('[TARIFAS #387] No se reenvian los valores de la config global que la herramienta '
            + (data.codigo || '') + ' arrastraba en su config: ' + limpio.quitadas.join(', ')
            + (TarifaHerramienta.esAlta(data) ? ' (es un alta: no hay predecesora que los conserve)' : ''));
    }
    const method = TarifaHerramienta.esAlta(data) ? 'POST' : 'PUT';
    let url = self.server_movilidad + self.prefix + self.model + '/';
    if (data.id) url += data.id;
    const request = {
        url: url,
        method: method,
        data: limpio.herramienta
    };
    return self.sendRequest(request, false);
};

export default TarifaHerramienta;
